<template>
    <div
        id="bbva-form-3"
        class="p-4 md:p-6 shadow"
        :class="blueForm ? 'bg-light-blue' : 'bg-gray2'"
    >
        <div
            class="flex"
            :class="actualForm > 3 ? 'cursor-pointer' : 'cursor-default'"
            @click="onFormClick"
        >
            <div>
                <div
                    class="rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium"
                    :class="[blueForm ? ['bg-white'] : ['bg-light-blue', 'text-white']]"
                >3</div>
            </div>
            <div
                class="ml-4"
                :class="blueForm ? 'text-white' : ''"
            >
                <p class="text-lg sm:text-2xl font-medium leading-none xs:leading-tight">Datos económicos</p>
                <p class="text-sm leading-tight mt-1 xs:mt-0">Recuerda que estos datos son obligatorios.</p>
            </div>
            <div class="ml-auto mt-2">
                <div
                    v-if="!blueForm"
                    :key="showForm"
                    :class="showForm ? 'triangle-up-black' : 'triangle-down-black'"
                ></div>
                <div
                    v-else
                    :key="showForm"
                    :class="showForm ? 'triangle-up-white' : 'triangle-down-white'"
                ></div>
            </div>
        </div>
        <div
            class="mt-4 form-3"
            :class="{'hidden': !showForm}"
        >
            <div class="line border-solid border-b border-gray3"></div>
            <ValidationObserver v-slot="{ handleSubmit }">
                <form
                    class="mt-4 xs:w-4/6 sm:w-5/6 lg:w-4/6 mx-auto leading-tight sm:leading-normal"
                    @submit.prevent="handleSubmit(onSubmit)"
                >
                    <div class="flex flex-col space-y-2">
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes, invalid }"
                            >
                                <v-select-form
                                    :name="'profession'"
                                    :invalid="invalid"
                                    :classes="classes"
                                    :options="catalogs.professions"
                                    :loading="loading.professions"
                                    v-model="formInputs.profession"
                                >
                                    Profesión*
                                </v-select-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes, invalid }"
                            >
                                <v-select-form
                                    :name="'economic_activity'"
                                    :invalid="invalid"
                                    :classes="classes"
                                    :options="catalogs.ecoActivities"
                                    :loading="loading.ecoActivities"
                                    v-model="formInputs.ecoActivity"
                                >
                                    Actividad Económica*
                                </v-select-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes, invalid }"
                            >
                                <v-select-form
                                    :name="'employment_situation'"
                                    :invalid="invalid"
                                    :classes="classes"
                                    :options="catalogs.empSituations"
                                    :loading="loading.empSituations"
                                    v-model="formInputs.empSituation"
                                >
                                    Situación Laboral*
                                </v-select-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required|month"
                                v-slot="{ errors, classes }"
                            >
                                <date-picker-form
                                    :classes="classes"
                                    name="residence_years"
                                    type="month"
                                    :value="formInputs.empStartDate"
                                    @change="formInputs.empStartDate = $event"
                                >
                                    Antigüedad laboral*
                                </date-picker-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <!-- <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes }"
                            >
                                <input-form
                                    :classes="classes"
                                    :type="'date'"
                                    :name="'emp_start_date'"
                                    :value="formInputs.empStartDate"
                                    @input="formInputs.empStartDate = $event"
                                >
                                    Fecha de inicio de empleo*
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider> -->
                        </div>
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes, invalid }"
                            >
                                <v-select-form
                                    :name="'ed_level'"
                                    :invalid="invalid"
                                    :classes="classes"
                                    :options="catalogs.edLevels"
                                    :loading="loading.edLevels"
                                    v-model="formInputs.edLevel"
                                >
                                    Nivel de estudios*
                                </v-select-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 sm:w-1/2">
                                <ValidationProvider
                                    class="sm:w-1/2"
                                    :rules="fixedIncomeRules"
                                    v-slot="{ errors, classes }"
                                >
                                    <input-form
                                        :classes="classes"
                                        :type="'text'"
                                        :name="'fixed_income'"
                                        v-model="formInputs.fixedIncome"
                                    >
                                        {{ `Ingreso fijo${fixedIncomeRules === 'numeric|required' ? '*' : ''}` }}
                                    </input-form>
                                    <span class="text-sm text-red">{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider
                                    class="sm:w-1/2"
                                    :rules="varIncomeRules"
                                    v-slot="{ errors, classes }"
                                >
                                    <input-form
                                        :classes="classes"
                                        :type="'text'"
                                        :name="'variable_income'"
                                        v-model="formInputs.varIncome"
                                    >
                                        {{ `Ingreso variable${varIncomeRules === 'numeric|required' ? '*' : ''}` }}
                                    </input-form>
                                    <span class="text-sm text-red">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required|numeric"
                                v-slot="{ errors, classes }"
                            >
                                <input-form
                                    :classes="classes"
                                    :type="'text'"
                                    :name="'dep_num'"
                                    v-model="formInputs.depNum"
                                >
                                    Núm. de dependientes*
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="mt-6 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 items-center justify-end">
                        <button
                            type="button"
                            class="hyundai-button w-40 py-0 h-8 bg-light-blue"
                            @click="saveProgress"
                            :disabled="savingProgress"
                        >{{ !savingProgress ? 'Guardar avance' : 'Guardando...' }}</button>
                        <button
                            type="submit"
                            class="hyundai-button w-40 py-0 h-8"
                        >Siguiente</button>
                    </div>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
// Components to form validations
import {
    ValidationProvider,
    ValidationObserver,
    setInteractionMode,
} from "vee-validate";
setInteractionMode("eager");
// Validaciones personalizadas para el formulario
import "../helpers/form_validations";
// Función para importar los catálogos
import { getCatalog } from "../helpers/helpers_functions";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: ["mainCheck", "actualForm", "savingProgress"],
    data() {
        return {
            showForm: false,
            formComplete: false,
            formInputs: {
                empStartDate: "",
                profession: "",
                edLevel: "",
                depNum: "",
                fixedIncome: "",
                varIncome: "",
                ecoActivity: "",
                empSituation: "",
            },
            catalogs: {
                professions: [],
                ecoActivities: [],
                empSituations: [],
                edLevels: [],
            },
            loading: {
                professions: false,
                ecoActivities: false,
                empSituations: false,
                edLevels: false,
            },
        };
    },
    watch: {
        showForm(newVal) {
            if (newVal) {
                this.$emit("form-open", 3);
                $(".form-3").slideDown();
                if (this.emptyCatalog) {
                    this.getCatalogs();
                }
            } else {
                this.$emit("form-closed", 3);
                $(".form-3").slideUp();
            }
        },
    },
    methods: {
        onFormClick() {
            if (this.mainCheck && !this.showForm && this.actualForm > 2) {
                this.$eventBus.$emit("hide-forms");
                this.showForm = true;
                this.formComplete = false;
            }
        },
        onSubmit(e) {
            if (!this.emptyCatalog) {
                // this.addInputsDesc();

                const formData = {
                    formNum: 3,
                    formInputs: { ...this.formInputs },
                };

                this.$emit("form-validated", formData);
            } else {
                this.$emit("charging-catalogs");
            }
        },
        // Function to add descriptions to formInputs based on id
        // addInputsDesc() {
        //     this.formInputs.professionDesc = this.formInputs.profession
        //         ? this.catalogs.professions.find(
        //               (option) => option.id === this.formInputs.profession
        //           ).description
        //         : "";
        //     this.formInputs.ecoActivityDesc = this.formInputs.ecoActivity
        //         ? this.catalogs.ecoActivities.find(
        //               (option) => option.id === this.formInputs.ecoActivity
        //           ).description
        //         : "";
        //     this.formInputs.empSitutationDesc = this.formInputs.empSituation
        //         ? this.catalogs.empSituations.find(
        //               (option) => option.id === this.formInputs.empSituation
        //           ).description
        //         : "";
        //     this.formInputs.edLevelDesc = this.formInputs.edLevel
        //         ? this.catalogs.edLevels.find(
        //               (option) => option.id === this.formInputs.edLevel
        //           ).description
        //         : "";
        // },
        saveProgress() {
            if (!this.emptyCatalog) {
                // this.addInputsDesc();

                const formData = {
                    formNum: 3,
                    formInputs: { ...this.formInputs },
                };

                this.$emit("save-progress", formData);
            } else {
                this.$emit("charging-catalogs");
            }
        },
        setInputs(inputs) {
            this.formInputs.empStartDate = inputs.workPlace_startDate;
            this.formInputs.empSituation = inputs.employmentSituation_id;
            this.formInputs.edLevel = inputs.education_id;
            this.formInputs.depNum = inputs.dependents;
            this.formInputs.ecoActivity = inputs.economicActivity_id;
            this.formInputs.profession = inputs.occupationType_id;
            this.formInputs.fixedIncome = inputs.fixed_income;
            this.formInputs.varIncome = inputs.variable_income;
        },
        getCatalogs() {
            this.loading.professions = true;
            getCatalog("PROFESSIONS")
                .then((resp) => {
                    this.catalogs.professions = resp;
                    this.loading.professions = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading.professions = false;
                });
            this.loading.ecoActivities = true;
            getCatalog("COMPANY_ACTIVITIES")
                .then((resp) => {
                    this.catalogs.ecoActivities = resp;
                    this.loading.ecoActivities = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading.ecoActivities = false;
                });
            this.loading.empSituations = true;
            getCatalog("EMPLOYMENT_SITUATIONS")
                .then((resp) => {
                    this.catalogs.empSituations = resp;
                    this.loading.empSituations = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading.empSituations = false;
                });
            this.loading.edLevels = true;
            getCatalog("EDUCATIONS")
                .then((resp) => {
                    this.catalogs.edLevels = resp;
                    this.loading.edLevels = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading.edLevels = false;
                });
        },
    },
    computed: {
        emptyCatalog() {
            let empty = false;
            for (const key in this.catalogs) {
                if (!this.catalogs[key].length) {
                    empty = true;
                    break;
                }
            }
            return empty;
        },
        blueForm() {
            return this.formComplete && this.actualForm > 2;
        },
        fixedIncomeRules() {
            let rules = "numeric";
            if (
                this.formInputs.empSituation &&
                (this.formInputs.empSituation.id === "1482" ||
                    this.formInputs.empSituation.id === "1483")
            ) {
                rules += "|required";
            }
            return rules;
        },
        varIncomeRules() {
            let rules = "numeric";
            if (
                this.formInputs.empSituation &&
                this.formInputs.empSituation.id === "1484"
            ) {
                rules += "|required";
            }
            return rules;
        },
    },
    created() {
        this.$eventBus.$on("show-form-3", () => {
            this.showForm = true;
            this.formComplete = false;
        });
        this.$eventBus.$on("hide-forms", () => {
            this.showForm = false;
        });
        this.$eventBus.$on("complete-form-3", () => {
            this.showForm = false;
            this.formComplete = true;
        });
        this.$eventBus.$on("setFormsInputs", (inputs) => {
            this.setInputs(inputs);
        });
    },
};
</script>

<style>
</style>